export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Notification-Gray-11cbddeea2a39b3b484000ca03ea3cbf.svg";